/**
 * GNB(글로벌 내비게이션 바) 메뉴 정의 — 단일 원천.
 *
 * 메뉴 증감(예: PORTFOLIO 제외)은 이 배열만 수정하면
 * 헤더 메뉴(widgets/site-header)와 준비중 페이지 라우트(app/routes)에 함께 반영된다.
 * HOME 은 루트(/)이며 로고와 GNB 첫 메뉴가 같은 HOME_PATH 로 연결한다.
 */

// index 가 아니라 paths 를 직접 읽는다 — index 는 이 파일을 재노출하므로 순환 import 가 된다.
import { ABOUT_PATH, PORTFOLIO_PATH, QUOTE_REQUEST_PATH, STORE_PATH } from './paths';

/** 기존 GNB public API를 유지하면서 경로 헬퍼와 같은 상수를 사용한다. */
export { PORTFOLIO_PATH, QUOTE_REQUEST_PATH } from './paths';

export interface GnbItem {
  readonly label: string;
  readonly path: string;
}

export const HOME_PATH = '/';
export { MY_PAGE_PATH } from './my-page-path';
/** 기획전 — GNB 메뉴와 기획전 카드·상품 목록의 "기획전 보러 가기"가 함께 쓴다. */
export const EXHIBITION_PATH = '/exhibition';

export const GNB_ITEMS: readonly GnbItem[] = [
  { label: 'HOME', path: HOME_PATH },
  { label: 'STORE', path: STORE_PATH },
  { label: '기획전', path: EXHIBITION_PATH },
  { label: 'PORTFOLIO', path: PORTFOLIO_PATH },
  { label: 'ABOUT', path: ABOUT_PATH },
  { label: '견적문의', path: QUOTE_REQUEST_PATH },
];
